module.exports = __webpack_public_path__ + "img/AI_11.3a1598a0.png";